


























































































































































































































































































import { defineComponent, reactive } from '@vue/composition-api'

import { UserRole } from '@/types/user'
import { ContributerState, UserState } from '@/types/store'
import { workTargets } from '@/types/log'
import { receiptSuppliers, genders } from '@/types/receipt'

import useVuex from '@/utils/useVuex'
import { baseURL } from '@/api/axios-default'

import Layout from '@/components/organisms/common/Layout.vue'
import { ContributersTable } from '@/components/organisms/contributers'

export default defineComponent({
  name: 'AdminContributers',
  components: { Layout, ContributersTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      contributers: useVuex<ContributerState['contributers']>(
        context,
        () => store.getters['contributer/contributers'],
      ),
      total: useVuex<ContributerState['total']>(
        context,
        () => store.getters['contributer/total'],
      ),
      isContributersLoading: useVuex<ContributerState['isContributersLoading']>(
        context,
        () => store.getters['contributer/isContributersLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      supplier: null,
      monitorId: null,
      receiptId: null,
      isContributedAtStartOpen: false,
      contributedAtStart: null,
      isContributedAtEndOpen: false,
      contributedAtEnd: null,
      isCompletedAtStartOpen: false,
      completedAtStart: null,
      isCompletedAtEndOpen: false,
      completedAtEnd: null,
      gender: null, // 0 | 1
      prefecture: null,
      age: null,
      chainStoreName: null,
      isPurchasedAtStartOpen: false,
      purchasedAtStart: null,
      isPurchasedAtEndOpen: false,
      purchasedAtEnd: null,
      workTarget: null,
    })

    const search = async () => {
      try {
        await store.dispatch('contributer/getContributers', {
          supplier: state.supplier,
          monitorId: state.monitorId,
          receiptId: state.receiptId,
          contributedAtStart: state.contributedAtStart,
          contributedAtEnd: state.contributedAtEnd,
          completedAtStart: state.completedAtStart,
          completedAtEnd: state.completedAtEnd,
          gender: state.gender,
          age: state.age,
          prefecture: state.prefecture,
          chainStoreName: state.chainStoreName,
          purchasedAtStart: state.purchasedAtStart,
          purchasedAtEnd: state.purchasedAtEnd,
          receiptStatus: state.workTarget,
        })
      } catch (_) {
        store.dispatch('contributer/reset')
        alert('タイムアウトしました。検索条件を変更して再度お試しください。')
      }
    }

    return {
      state,
      search,
      UserRole,
      baseURL,
      receiptSuppliers,
      genders,
      workTargets,
    }
  },
})
